/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, Fragment, useState } from "react";
import { Grid } from "@material-ui/core";
import Controls from "../../component/controls/Controls";
import { useForm, Form } from "../../component/useForm";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import InputAdornment from "@mui/material/InputAdornment";
import { updateProfite } from "../../redux/profit";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Checkbox } from "@mui/material";
import { updatePayment } from "../../redux/payment";

function Editpayment(props) {
  const dispatch = useDispatch();
  const [CheckLock, setCheckLock] = useState(false);
  const { Paymentid, loadingUpdate, loading } = useSelector(
    (state) => state.Payments
  );
  const initialFValues = {
    id: props.id_company,
    type_name_en: "",
    type_name_ar: "",
  };
  useEffect(() => {
    if (Paymentid) {
      
      const { type_name_en, type_name_ar, active, config } = Paymentid;
  
      // تعيين القيم الافتراضية للنموذج
      setValues({
        id: props.id_company,
        type_name_en: type_name_en || "",
        type_name_ar: type_name_ar || "",
      });
  
      // تعيين حالة CheckLock بناءً على `active`
      setCheckLock(active === "1");
  
      // تحليل وتعبئة الحقول بناءً على `config`
      if (config) {
        let parsedConfig;
  
        // Ensure `config` is parsed as an object
        if (typeof config === "string") {
         
          try {
            parsedConfig = JSON.parse(config); // Parse if it's a string
          } catch (error) {
            console.error("Failed to parse config:", error);
            parsedConfig = {}; // Default to an empty object if parsing fails
          }
        } else {
    
          parsedConfig = config; // Use as is if already an object
        }
  
        const parsedFields = Object.entries(parsedConfig).map(([key, value]) => {
          let typeSend = "string"; // النوع الافتراضي
          let type = "text"; // نوع الإدخال الافتراضي
          let parsedValue;
     
          
          try {
            // تحليل القيمة (للتأكد من وجود array أو object)
            parsedValue = value;

  
            // تحديد النوع بناءً على القيمة المحللة
            if (Array.isArray(value)) {
              typeSend = "array";
            } else if (typeof value === "object") {
              typeSend = "object";
            } else if (typeof value === "number") {
              typeSend = "integer";
              type = "number"; // إدخال رقمي
            } else {
              typeSend = "string";
            }
          } catch (error) {
           
            // إذا كانت القيمة ليست JSON صالحة، اعتبرها نصًا عاديًا
            typeSend = "string";
            parsedValue = value;
          }
  
          // إرجاع الحقل المحلل
          return {
            name: key,
            type: type,
            typeSend: typeSend,
            value: Array.isArray(value)
              ? JSON.stringify(value) // تحويل المصفوفات إلى نص
              : typeof value === "object"
              ? JSON.stringify(value, null, 2) // تنسيق الكائنات
              : value, // القيم النصية أو الرقمية
          };
        });
  
        setFields(parsedFields);
      }
    }
  }, [Paymentid, props.id_company]);
  
  // useEffect(() => {
  //   if (Paymentid) {
  //     const { type_name_en, type_name_ar, active, config } = Paymentid;
  
  //     // تعيين القيم الافتراضية للنموذج
  //     setValues({
  //       id: props.id_company,
  //       type_name_en: type_name_en || "",
  //       type_name_ar: type_name_ar || "",
  //     });
  
  //     // تعيين حالة CheckLock بناءً على `active`
  //     setCheckLock(active === "1");
  
  //     // تحليل وتعبئة الحقول بناءً على `config`
  //     if (config) {
  //       const parsedFields = Object.entries(config).map(([key, value]) => {
  //         let typeSend = "string"; // النوع الافتراضي
  //         let type = "text"; // نوع الإدخال الافتراضي
  //         let parsedValue;
  
  //         try {
  //           // تحليل القيمة (للتأكد من وجود array أو object)
  //           parsedValue = JSON.parse(value);
  
  //           // تحديد النوع بناءً على القيمة المحللة
  //           if (Array.isArray(parsedValue)) {
  //             typeSend = "array";
  //           } else if (typeof parsedValue === "object") {
  //             typeSend = "object";
  //           } else if (typeof parsedValue === "number") {
  //             typeSend = "integer";
  //             type = "number"; // إدخال رقمي
  //           } else {
  //             typeSend = "string";
  //           }
  //         } catch (error) {
  //           // إذا كانت القيمة ليست JSON صالحة، اعتبرها نصًا عاديًا
  //           typeSend = "string";
  //           parsedValue = value;
  //         }
  
  //         // إرجاع الحقل المحلل
  //         return {
  //           name: key,
  //           type: type,
  //           typeSend: typeSend,
  //           value: Array.isArray(parsedValue)
  //             ? JSON.stringify(parsedValue) // تحويل المصفوفات إلى نص
  //             : typeof parsedValue === "object"
  //             ? JSON.stringify(parsedValue, null, 2) // تنسيق الكائنات
  //             : parsedValue, // القيم النصية أو الرقمية
  //         };
  //       });
  
  //       setFields(parsedFields);
  //     }
  //   }
  // }, [Paymentid, props.id_company]);
  
    // useEffect(() => {
    //   if (Paymentid) {
    //     const { type_name_en, type_name_ar, active, config } = Paymentid;
    
    //     // Set form values
    //     setValues({
    //       id: props.id_company,
    //       type_name_en: type_name_en || "",
    //       type_name_ar: type_name_ar || "",
    //     });
    
    //     // Set CheckLock based on `active`
    //     setCheckLock(active === "1");
    
    //     // Populate fields based on `config`
    //     if (config) {
    //       const parsedFields = Object.entries(config).map(([key, value]) => {
    //         try {
    //           const parsedValue = JSON.parse(value); // Parse the value (handles arrays and objects)
    //           return {
    //             name: key,
    //             type: typeof parsedValue === "number" ? "number" : "text",
    //             typeSend: Array.isArray(parsedValue) ? "array" : "object",
    //             value: Array.isArray(parsedValue)
    //               ? JSON.stringify(parsedValue) // Convert arrays to a string representation
    //               : JSON.stringify(parsedValue, null, 2), // Format objects nicely
    //           };
    //         } catch (error) {
    //           // Handle string values or invalid JSON
    //           return {
    //             name: key,
    //             type: "text",
    //             typeSend: "string",
    //             value, // Use the raw value
    //           };
    //         }
    //       });
    
    //       setFields(parsedFields);
    //     }
    //   }
    // }, [Paymentid, props.id_company]);
    
  const handleCheckboxChangeLock = (event) => {
    setCheckLock(event.target.checked);
    // Toggle the description based on whether the checkbox is checked
    if (event.target.checked) {
      setValues({
        ...values,
        is_lock: "1", // Customize this default description
      });
    } else {
      setValues({
        ...values,
        is_lock: "0",
      });
    }
  };

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("type_name_en" in fieldValues)
      temp.type_name_en = fieldValues.type_name_en ? "" : "هذا الحقل مطلوب";
    if ("type_name_ar" in fieldValues)
      temp.type_name_ar = fieldValues.type_name_ar ? "" : "هذا الحقل مطلوب";

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    true,
    validate
  );
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      if (validateForm()) {
        const config = fields.reduce((acc, field) => {
          if (!field.name) return acc; // Skip fields without names

          let processedValue;

          // Process the value based on typeSend
          switch (field.typeSend) {
            case "array":
              try {
                // Parse the value as JSON
                processedValue = JSON.parse(field.value.trim());

                // Check if the parsed value is an array
                if (!Array.isArray(processedValue)) {
                  throw new Error(
                    `Invalid array format for field ${field.name}`
                  );
                }

                // Check if the array contains objects or simple values
                processedValue = processedValue.map((item) => {
                  if (typeof item === "object" && item !== null) {
                    return item; // Valid object
                  } else if (
                    typeof item === "string" ||
                    typeof item === "number"
                  ) {
                    return item; // Valid primitive
                  } else {
                    throw new Error(
                      `Invalid array item format in field ${field.name}`
                    );
                  }
                });
              } catch (error) {
                console.error(
                  `Invalid array input for field ${field.name}:`,
                  error
                );
                alert(
                  `Invalid array format for field "${field.name}". Please use valid JSON syntax, e.g., [{"key1":"value1"},{"key2":"value2"}]`
                );
                return acc; // Skip adding this field to the config
              }
              break;

            case "integer":
              // Parse value as an integer
              processedValue = parseInt(field.value.trim(), 10);
              if (isNaN(processedValue)) {
                alert(
                  `Invalid integer format for field "${field.name}". Please enter a valid number.`
                );
                return acc;
              }
              break;

              case 'object':
                try {
                  // Check if the input uses custom object syntax {{...},{...}}
                  if (field.value.trim().startsWith('{{') && field.value.trim().endsWith('}}')) {
                    // Step 1: Remove the outer `{{` and `}}`
                    const innerContent = field.value.trim().slice(2, -2);
              
                    // Step 2: Split the content into individual object strings
                    const objectStrings = innerContent.split('},{');
              
                    // Step 3: Parse each individual object string into a valid JSON object
                    const parsedObjects = objectStrings.map((item) => {
                      const jsonString = `{${item}}`; // Wrap with braces to make it a valid JSON object
                      return JSON.parse(jsonString);
                    });
              
                    // Step 4: Combine parsed objects into a single object with unique keys
                    processedValue = parsedObjects.reduce((acc, obj, index) => {
                      acc[`object_${index + 1}`] = obj; // Assign a unique key to each parsed object
                      return acc;
                    }, {});
                  } else {
                    // Fallback: Parse as a normal JSON object
                    processedValue = JSON.parse(field.value.trim());
                    if (typeof processedValue !== 'object' || Array.isArray(processedValue)) {
                      throw new Error(`Invalid object format for field ${field.name}`);
                    }
                  }
                } catch (error) {
                  console.error(`Invalid object input for field ${field.name}:`, error);
                  alert(
                    `Invalid object format for field "${field.name}". Please use valid syntax, e.g., {"key1":"value1","key2":"value2"} or {{...},{...}}`
                  );
                  return acc; // Skip adding this field to the config
                }
                break;
              
            case "string":
            default:
              // Treat the value as a simple string
              processedValue = field.value.trim();
              break;
          }

          // Add the processed value to the config object
          acc[field.name] = processedValue;
          return acc;
        }, {});

        const data={
          id:values.id,
          type_name_en:values.type_name_en,
          type_name_ar:values.type_name_ar,
          active: CheckLock ? "1" : "0", // Send 1 if true, else 
          config:config,
        }
        dispatch(updatePayment(data)); // Dispatch the config
      }
    }
  };

 
  const [fields, setFields] = useState([
    { name: "", type: "text", typeSend: "string", value: "" },
  ]);

  const handleAddField = () => {
    setFields([
      ...fields,
      { name: "", type: "text", typeSend: "string", value: "" },
    ]);
    handleSendArray();  };
  const handleSendArray = () => {
    // Call the array for sending
  };
  const handleRemoveField = (index) => {
    setFields(fields.filter((_, i) => i !== index));
  };

  const handleChange = (index, field, value) => {
    setFields((prevFields) =>
      prevFields.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      )
    );
  };


  const validateForm = () => {
    const uniqueNames = new Set(fields.map((field) => field.name));
    if (uniqueNames.size !== fields.length) {
      alert("Field names must be unique!");
      return false;
    }
    return true;
  };

  return (
    <Form onSubmit={handleSubmit}>
      {loading ? (
        <div className="spinner1-box">
          <svg class="spinner1" viewBox="0 0 50 50">
            <circle
              class="path1"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke-width="5"
            ></circle>
          </svg>
        </div>
      ) : (
        <Grid className="createdTrip">
          <Grid item xs={12} md={12} sm={12}>
            <Grid
              item
              xs={12}
              md={12}
              sm={12}
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row-reverse",
              }}
            >
              <Controls.Input
                className="tesr122"
                name="type_name_en"
                label={
                  <Fragment>
                    <InputAdornment position="end">
                      <span className="placeholdertitle">
                        اسم طريقة الدفع بالإنكليزي
                      </span>
                    </InputAdornment>
                  </Fragment>
                }
                value={values.type_name_en}
                onChange={handleInputChange}
                error={errors.type_name_en}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              sm={12}
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row-reverse",
              }}
            >
              <Controls.Input
                className="tesr122"
                name="type_name_ar"
                label={
                  <Fragment>
                    <InputAdornment position="end">
                      <span className="placeholdertitle">
                        اسم طريقة الدفع بالعربي
                      </span>
                    </InputAdornment>
                  </Fragment>
                }
                value={values.type_name_ar}
                onChange={handleInputChange}
                error={errors.type_name_ar}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              sm={12}
              style={{
                direction: "rlt !important",
                display: "flex",
                justifyContent: "end",
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={CheckLock}
                    onChange={handleCheckboxChangeLock}
                    name="active"
                  />
                }
                label="تفعيل طريقة الدفع"
              />
            </Grid>
            <button 
            type="button" 
            onClick={handleAddField} 
            style={{
              padding: "10px 20px",
              backgroundColor: "#28a745",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              marginBottom: "10px"
            }}
          >
            إضافة
          </button>
            {fields.map((field, index) => (
              <div
                key={index}
                style={{
                  marginBottom: "15px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  border: "1px solid #ddd",
                  padding: "10px",
                  borderRadius: "5px",
                  backgroundColor: "#f9f9f9",
                }}
              >
                <input
                  type="text"
                  placeholder="ادخل اسم الحقل"
                  value={field.name}
                  onChange={(e) => handleChange(index, "name", e.target.value)}
                  style={{
                    padding: "5px",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    flex: "1",
                  }}
                />
                <select
                  value={field.type}
                  onChange={(e) => handleChange(index, "type", e.target.value)}
                  style={{
                    padding: "5px",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    flex: "1",
                  }}
                >
                  <option value="text">Text</option>
                  <option value="number">Number</option>
                  <option value="email">Email</option>
                  <option value="password">Password</option>
                </select>
                <select
                  value={field.typeSend}
                  onChange={(e) => handleChange(index, "typeSend", e.target.value)}
                  style={{
                    padding: "5px",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    flex: "1",
                  }}
                >
                  <option value="array">array</option>
                  <option value="string">string</option>
                  <option value="object">object</option>
                  <option value="integer">integer</option>
                </select>
                <input
                  type={field.type}
                  name={field.name}
                  placeholder="ادخل قيمة الحقل"
                  value={field.value}
                  onChange={(e) => handleChange(index, "value", e.target.value)}
                  style={{
                    padding: "5px",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    flex: "2",
                  }}
                />
                <button
                  type="button"
                  onClick={() => handleRemoveField(index)}
                  style={{
                    padding: "5px 10px",
                    backgroundColor: "#dc3545",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                >
                  Remove
                </button>
              </div>
            ))}
          </Grid>
        </Grid>
      )}
      <Grid xs={12} md={12}>
        {loadingUpdate ? (
          <div
            className="bottonFullwidth"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              className="load loadingupdate"
              style={{ background: "#F9B917", borderRaduis: "10px" }}
            >
              <div v-if="loading" class="spinner">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </div>
        ) : (
          <div
            className="bottonFullwidth"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Controls.Button type="submit" text="تعديل" />
          </div>
        )}
      </Grid>
    </Form>
  );
}
export default Editpayment;
